var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Do(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_69171)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9973 4.42256C11.7119 4.07587 9.25982 4.13531 7.04459 4.59415C4.84627 5.0495 2.92183 5.89065 1.67212 7.05984C0.389468 8.25979 -0.170346 9.82677 0.460051 11.4116C1.04606 12.8848 2.53763 14.0297 4.40001 14.7941C6.03267 15.4641 7.9895 15.8614 10.0188 15.9584V17.9455L13.9455 15.1035L10.0188 12.0546V13.9923C8.2128 13.8968 6.51592 13.5399 5.14536 12.9774C3.49645 12.3008 2.58453 11.4404 2.28436 10.6858C2.02859 10.0428 2.15476 9.29718 3.01336 8.49386C3.9049 7.65978 5.4445 6.9309 7.44277 6.51699C9.42416 6.10658 11.6416 6.0513 13.7029 6.36399C15.7761 6.67848 17.4834 7.33301 18.5746 8.14973C19.6641 8.96513 19.9297 9.75873 19.8068 10.3824C19.6697 11.0785 18.9913 11.9398 17.5029 12.6841C17.0181 12.9266 16.8214 13.5163 17.0639 14.0013C17.3064 14.4863 17.8961 14.6829 18.3811 14.4404C20.1047 13.5785 21.4251 12.3264 21.7332 10.762C22.0556 9.12507 21.1851 7.65085 19.751 6.57754C18.3187 5.50559 16.2709 4.76745 13.9973 4.42256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_69171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(0.200195 0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Do);
export default __webpack_public_path__ + "static/media/3do.859c65685ffa4b45c2d08ab00ae77cb1.svg";
export { ForwardRef as ReactComponent };